import DepartmentRequestDoc from "components/department-request-document/UploadDucumentStep";
import UploadDucumentStepLTR from "components/department-request-document/UploadDucumentStepLTR";
import LastStepDependent from "components/ltr-request-document/Dependent/LastStep";
import SummarizeDependent from "components/ltr-request-document/Dependent/SummarizeStep";
import UploadDocumentDependent from "components/ltr-request-document/Dependent/UploadDucumentStep";
import UploadPassportDependent from "components/ltr-request-document/Dependent/UploadPassport";
import UserProfileDependent from "components/ltr-request-document/Dependent/UserProfile";

import LastStepGlobalCitizen from "components/ltr-request-document/globalCitizen/LastStep";
import SummarizeGlobalCitizen from "components/ltr-request-document/globalCitizen/SummarizeStep";
import UploadDocumentGlobalCitizen from "components/ltr-request-document/globalCitizen/UploadDucumentStep";
import UploadPassportGlobalCitizen from "components/ltr-request-document/globalCitizen/UploadPassport";
import UserProfileCitizen from "components/ltr-request-document/globalCitizen/UserProfile";

import LastStepWorkPermit from "components/workpermit/LastStep";
import SummarizeWorkPermit from "components/workpermit/SummarizeStep";
import UploadDocumentWorkPermit from "components/workpermit/UploadDucumentStep";
import UploadPassportWorkPermit from "components/workpermit/UploadPassport";
import UserProfileWorkPermit from "components/workpermit/UserProfile";

import LastStepWorkEditorPermit from "components/workpermitEditor/LastStep";
import SummarizeWorkEditorPermit from "components/workpermitEditor/SummarizeStep";
import UploadDocumentWorkEditorPermit from "components/workpermitEditor/UploadDucumentStep";
import UploadPassportWorkEditorPermit from "components/workpermitEditor/UploadPassport";
import UserProfileWorkEditorPermit from "components/workpermitEditor/UserProfile";

import LastStepGoverment from "components/ltr-request-document/Goverment/LastStep";
import SummarizeGoverment from "components/ltr-request-document/Goverment/SummarizeStep";
import UploadDocumentGoverment from "components/ltr-request-document/Goverment/UploadDucumentStep";
import UploadPassportGoverment from "components/ltr-request-document/Goverment/UploadPassport";
import UserProfileGoverment from "components/ltr-request-document/Goverment/UserProfile";
import LastStepPensioner from "components/ltr-request-document/Pensioner/LastStep";
import SummarizePensioner from "components/ltr-request-document/Pensioner/SummarizeStep";
import UploadDocumentPensioner from "components/ltr-request-document/Pensioner/UploadDucumentStep";
import UploadPassportPensioner from "components/ltr-request-document/Pensioner/UploadPassport";
import UserProfilePensioner from "components/ltr-request-document/Pensioner/UserProfile";
import LastStepPrivateCompany from "components/ltr-request-document/PrivateCompanyHighSkill/LastStep";
import SummarizePrivateCompany from "components/ltr-request-document/PrivateCompanyHighSkill/SummarizeStep";
import UploadDocumentPrivateCompany from "components/ltr-request-document/PrivateCompanyHighSkill/UploadDucumentStep";
import UploadPassportPrivateCompany from "components/ltr-request-document/PrivateCompanyHighSkill/UploadPassport";
import UserProfilePrivateCompany from "components/ltr-request-document/PrivateCompanyHighSkill/UserProfile";
import LastStepProfessional from "components/ltr-request-document/Professional/LastStep";
import SummarizeProfessional from "components/ltr-request-document/Professional/SummarizeStep";
import UploadDocumentProfessional from "components/ltr-request-document/Professional/UploadDucumentStep";
import UploadPassportProfessional from "components/ltr-request-document/Professional/UploadPassport";
import UserProfileProfessional from "components/ltr-request-document/Professional/UserProfile";
import DocumentList from "components/request-document/DocumentList";
import ExecutiveSummarizeStep from "components/request-document/executive/SummarizeStep";
import ExecutiveSurveyStep from "components/request-document/executive/SurveyStep";
import ExecutiveUploadDucumentStep from "components/request-document/executive/UploadDucumentStep";
import ExecutiveUploadPassport from "components/request-document/executive/UploadPassport";
import ExecutiveUserProfileStep from "components/request-document/executive/UserProfileStep";
import ExecutiveUserProfileStep2 from "components/request-document/executive/UserProfileStep2";
import ExecutiveUserProfileStepB from "components/request-document/executive/UserProfileStepB";
import ExecutiveUserProfileStepC from "components/request-document/executive/UserProfileStepC";
import InvestorSummarizeStep from "components/request-document/investor/SummarizeStep";
import InvestorSurveyStep from "components/request-document/investor/SurveyStep";
import InvestorUploadDucumentStep from "components/request-document/investor/UploadDucumentStep";
import InvestorUploadPassport from "components/request-document/investor/UploadPassport";
import InvestorUserProfileStep from "components/request-document/investor/UserProfileStep";
import InvestorUserProfileStep2 from "components/request-document/investor/UserProfileStep2";
import InvestorUserProfileStepB from "components/request-document/investor/UserProfileStepB";
import InvestorUserProfileStepC from "components/request-document/investor/UserProfileStepC";
import InvestorVisaIssuanceStep from "components/request-document/investor/VisaIssuanceStep";
import OtherSummarizeStep from "components/request-document/other/SummarizeStep";
import OtherSurveyStep from "components/request-document/other/SurveyStep";
import OtherUploadDucumentStep from "components/request-document/other/UploadDucumentStep";
import OtherUploadPassport from "components/request-document/other/UploadPassport";
import OtherUserProfileStep from "components/request-document/other/UserProfileStep";
import OtherUserProfileStepB from "components/request-document/other/UserProfileStepB";
import StartUpHealthInsuranceStep from "components/request-document/startup/HealthInsuranceStep";
import StartUpSummarizeStep from "components/request-document/startup/SummarizeStep";
import StartUpSurveyStep from "components/request-document/startup/SurveyStep";
import StartUpUploadDucumentStep from "components/request-document/startup/UploadDucumentStep";
import StartUpUploadPassport from "components/request-document/startup/UploadPassport";
import StartUpUserProfileStep from "components/request-document/startup/UserProfileStep";
import StartUpUserProfileStep2 from "components/request-document/startup/UserProfileStep2";
import StartUpUserProfileStepB from "components/request-document/startup/UserProfileStepB";
import StartUpUserProfileStepC from "components/request-document/startup/UserProfileStepC";
import StartUpUserProfileStepD from "components/request-document/startup/UserProfileStepD";
import UserProfileStepE from "components/request-document/startup/UserProfileStepE";
import StartUpVisaIssuanceStep from "components/request-document/startup/VisaIssuanceStep";
import TalentSummarizeStep from "components/request-document/talent/SummarizeStep";
import TalentSurveyStep from "components/request-document/talent/SurveyStep";
import TalentUploadDucumentStep from "components/request-document/talent/UploadDucumentStep";
import TalentUploadPassport from "components/request-document/talent/UploadPassport";
import TalentUserProfileStep from "components/request-document/talent/UserProfileStep";
import TalentUserProfileStep2 from "components/request-document/talent/UserProfileStep2";
import TalentUserProfileStepB from "components/request-document/talent/UserProfileStepB";
import TalentUserProfileStepC from "components/request-document/talent/UserProfileStepC";
import ChangeAddCompanyInvestmentStep from "components/smart-visa-change/AddCompanyInvestmentStep";
import ChangeAddJobPositionStep from "components/smart-visa-change/AddJobPositionStep";
import ChangeUpdateCompanyInfoStep from "components/smart-visa-change/UpdateCompanyInfoStep";
import ChangeUpdateJobPositionStep from "components/smart-visa-change/UpdateJobPositionStep";
import ChangeUploadDucumentStep from "components/smart-visa-change/UploadDucumentStep";
import FromA from "components/smart-visa-extension/FromA";
import ExtensionHealthInsuranceStep from "components/smart-visa-extension/HealthInsuranceStep";
import PartA from "components/smart-visa-extension/PartA";
import PartB from "components/smart-visa-extension/PartB";
import PartC from "components/smart-visa-extension/PartC";
import PartD from "components/smart-visa-extension/PartD";
import PartE from "components/smart-visa-extension/PartE";
import PartF from "components/smart-visa-extension/PartF";
import PartG from "components/smart-visa-extension/PartG";
import PartUploadDucument from "components/smart-visa-extension/PartUploadDucument";
import { STATUS_PROCESS } from "libs/configs/constant";
import { LTR_STEP, SMART_T_STEP } from "libs/constant/Step";
import _ from "lodash";
import { useSelector } from "react-redux";
import {
  selectIsChange,
  selectIsExtension,
  selectSmartFormStep
} from "redux/modules/uiSlice";
import {
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectSmartService,
  selectSmartServiceLTR
} from "redux/modules/visaForm";

function DepartmentRequestDocStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <DepartmentRequestDoc />;
    default:
      return <DocumentList />;
  }
}

function ExtensionStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.PART_A_1:
      return <PartA />;
    case SMART_T_STEP.PART_B:
      return <PartB />;
    case SMART_T_STEP.PART_C:
      return <PartC />;
    case SMART_T_STEP.PART_D:
      return <PartD />;
    case SMART_T_STEP.PART_E:
      return <PartE />;
    case SMART_T_STEP.PART_F:
      return <PartF />;
    case SMART_T_STEP.PART_G:
      return <PartG />;
    case SMART_T_STEP.FROM_A:
      return <FromA />;
    case SMART_T_STEP.HEALTH_INSUANCE:
      return <ExtensionHealthInsuranceStep />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <DepartmentRequestDoc />;
      return <PartUploadDucument />;
    default:
      return <DocumentList />;
  }
}

function ChangeStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.ADD_JOB_POSITION:
      return <ChangeAddJobPositionStep />;
    case SMART_T_STEP.UPDATE_JOB_POSITION:
      return <ChangeUpdateJobPositionStep />;
    case SMART_T_STEP.UPDATE_COMPANY_INFO:
      return <ChangeUpdateCompanyInfoStep />;
    case SMART_T_STEP.ADD_COMPAMY_INVESTMENT:
      return <ChangeAddCompanyInvestmentStep />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <DepartmentRequestDoc />;
      return <ChangeUploadDucumentStep />;
    default:
      return <DocumentList />;
  }
}

function SmartSStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <StartUpUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <StartUpUserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <StartUpUserProfileStep2 />;
    case SMART_T_STEP.PART_B:
      return <StartUpUserProfileStepB />;
    case SMART_T_STEP.PART_C:
      return <StartUpUserProfileStepC />;
    case SMART_T_STEP.PART_D:
      return <StartUpUserProfileStepD />;
    case SMART_T_STEP.PART_E:
      return <UserProfileStepE />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <DepartmentRequestDoc />;
      return <StartUpUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <StartUpSurveyStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <StartUpSummarizeStep />;
    case SMART_T_STEP.VISA_INSUANCE:
      return <StartUpVisaIssuanceStep />;
    case SMART_T_STEP.HEALTH_INSUANCE:
      return <StartUpHealthInsuranceStep />;

    default:
      return <DocumentList />;
  }
}

function SmartOStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <OtherUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <OtherUserProfileStep />;
    case SMART_T_STEP.PART_B:
      return <OtherUserProfileStepB />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <DepartmentRequestDoc />;
      return <OtherUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <OtherSurveyStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <OtherSummarizeStep />;
    default:
      return <DocumentList />;
  }
}

function SmartIStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <InvestorUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <InvestorUserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <InvestorUserProfileStep2 />;
    case SMART_T_STEP.PART_B:
      return <InvestorUserProfileStepB />;
    case SMART_T_STEP.PART_C:
      return <InvestorUserProfileStepC />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <DepartmentRequestDoc />;
      return <InvestorUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <InvestorSurveyStep />;
    case SMART_T_STEP.VISA_INSUANCE:
      return <InvestorVisaIssuanceStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <InvestorSummarizeStep />;
    default:
      return <DocumentList />;
  }
}

function SmartEStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <ExecutiveUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <ExecutiveUserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <ExecutiveUserProfileStep2 />;
    case SMART_T_STEP.PART_B:
      return <ExecutiveUserProfileStepB />;
    case SMART_T_STEP.PART_C:
      return <ExecutiveUserProfileStepC />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <DepartmentRequestDoc />;
      return <ExecutiveUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <ExecutiveSurveyStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <ExecutiveSummarizeStep />;
    default:
      return <DocumentList />;
  }
}

function SmartTStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <TalentUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <TalentUserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <TalentUserProfileStep2 />;
    case SMART_T_STEP.PART_B:
      return <TalentUserProfileStepB />;
    case SMART_T_STEP.PART_C:
      return <TalentUserProfileStepC />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <DepartmentRequestDoc />;
      return <TalentUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <TalentSurveyStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <TalentSummarizeStep />;
    default:
      return <DocumentList />;
  }
}

function LTR_GlobalCitizen({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case LTR_STEP.UPLOAD_PASSPORT:
      return <UploadPassportGlobalCitizen />;
    case LTR_STEP.SHOW_FORM_STEP:
      return <UserProfileCitizen />;
    case LTR_STEP.SHOW_FORM_WORKPERMITSTEP:
      return <LastStepGlobalCitizen />;
    case LTR_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <UploadDucumentStepLTR />;
      return <UploadDocumentGlobalCitizen />;
    case LTR_STEP.SUMMARIZE:
      return <SummarizeGlobalCitizen />;
    default:
      return <DocumentList />;
  }
}

function LTR_WFT({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case LTR_STEP.UPLOAD_PASSPORT:
      return <UploadPassportProfessional />;
    case LTR_STEP.SHOW_FORM_STEP:
      return <UserProfileProfessional />;
    case LTR_STEP.SHOW_FORM_WORKPERMITSTEP:
      return <LastStepProfessional />;
    case LTR_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <UploadDucumentStepLTR />;
      return <UploadDocumentProfessional />;
    case LTR_STEP.SUMMARIZE:
      return <SummarizeProfessional />;
    default:
      return <DocumentList />;
  }
}

function LTR_Pensioner({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case LTR_STEP.UPLOAD_PASSPORT:
      return <UploadPassportPensioner />;
    case LTR_STEP.SHOW_FORM_STEP:
      return <UserProfilePensioner />;
    case LTR_STEP.SHOW_FORM_WORKPERMITSTEP:
      return <LastStepPensioner />;
    case LTR_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <UploadDucumentStepLTR />;
      return <UploadDocumentPensioner />;
    case LTR_STEP.SUMMARIZE:
      return <SummarizePensioner />;
    default:
      return <DocumentList />;
  }
}

function LTR_Dependent({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);
  // console.log(isRequestAddDoc);
  switch (smartFormStep) {
    case LTR_STEP.UPLOAD_PASSPORT:
      return <UploadPassportDependent />;
    case LTR_STEP.SHOW_FORM_STEP:
      return <UserProfileDependent />;
    case LTR_STEP.SHOW_FORM_WORKPERMITSTEP:
      return <LastStepDependent />;
    case LTR_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <UploadDucumentStepLTR />;
      return <UploadDocumentDependent />;
    case LTR_STEP.SUMMARIZE:
      return <SummarizeDependent />;
    default:
      return <DocumentList />;
  }
}

function LTR_Goverment({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case LTR_STEP.UPLOAD_PASSPORT:
      return <UploadPassportGoverment />;
    case LTR_STEP.SHOW_FORM_STEP:
      return <UserProfileGoverment />;
    case LTR_STEP.SHOW_FORM_WORKPERMITSTEP:
      return <LastStepGoverment />;

    case LTR_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <UploadDucumentStepLTR />;
      return <UploadDocumentGoverment />;
    case LTR_STEP.SUMMARIZE:
      return <SummarizeGoverment />;
    default:
      return <DocumentList />;
  }
}

function LTR_Private({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case LTR_STEP.UPLOAD_PASSPORT:
      return <UploadPassportPrivateCompany />;
    case LTR_STEP.SHOW_FORM_STEP:
      return <UserProfilePrivateCompany />;
    case LTR_STEP.SHOW_FORM_WORKPERMITSTEP:
      return <LastStepPrivateCompany />;
    case LTR_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <UploadDucumentStepLTR />;
      return <UploadDocumentPrivateCompany />;
    case LTR_STEP.SUMMARIZE:
      return <SummarizePrivateCompany />;
    default:
      return <DocumentList />;
  }
}

function WorkPermisStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case LTR_STEP.UPLOAD_PASSPORT:
      return <UploadPassportWorkPermit />;
    case LTR_STEP.SHOW_FORM_STEP:
      return <UserProfileWorkPermit />;
    case LTR_STEP.SHOW_FORM_WORKPERMITSTEP:
      return <LastStepWorkPermit />;
    case LTR_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <UploadDucumentStepLTR />;
      return <UploadDocumentWorkPermit />;
    case LTR_STEP.SUMMARIZE:
      return <SummarizeWorkPermit />;
    default:
      return <DocumentList />;
  }
}

function WorkPermisEditorStep({ isRequestAddDoc }) {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case LTR_STEP.UPLOAD_PASSPORT:
      return <UploadPassportWorkEditorPermit />;
    case LTR_STEP.SHOW_FORM_STEP:
      return <UserProfileWorkEditorPermit />;
    case LTR_STEP.SHOW_FORM_WORKPERMITSTEP:
      return <LastStepWorkEditorPermit />;
    case LTR_STEP.UPLOAD_DOCUMENT:
      if (isRequestAddDoc) return <UploadDucumentStepLTR />;
      return <UploadDocumentWorkEditorPermit />;
    case LTR_STEP.SUMMARIZE:
      return <SummarizeWorkEditorPermit />;
    default:
      return <DocumentList />;
  }
}

export default function StepContainer() {
  const smartserviceId = useSelector(selectCurrentSmartServiceId);
  const smartService = useSelector(selectSmartService);
  const smartServiceLTR = useSelector(selectSmartServiceLTR);
  const isExtension = useSelector(selectIsExtension);
  const isChange = useSelector(selectIsChange);
  const currentSmartForm = useSelector(selectCurrentSmartForm);
  const currentSmart =
    _.get(smartService, "data", []).find(
      (v) => v.smartserviceId === smartserviceId
    ) ||
    _.get(smartServiceLTR, "data", []).find(
      (v) => v.smartserviceId === smartserviceId
    );

  const smartserviceName = _.get(currentSmart, "smartserviceName", "");
  const smartserviceNameLTR = _.get(currentSmart, "smartserviceId", "");
  const typeDocSmartFromID = _.get(currentSmartForm, "typeDocSmartFromID", "");
  const statausID = _.get(currentSmartForm, "statausID", "");

  const isRequestAddDoc = statausID === STATUS_PROCESS.RequestAddDoc;

  if (isExtension || typeDocSmartFromID === "E") {
    return <ExtensionStep isRequestAddDoc={isRequestAddDoc} />;
  }

  if (isChange || typeDocSmartFromID === "C") {
    return <ChangeStep isRequestAddDoc={isRequestAddDoc} />;
  }

  // if (statausID === STATUS_PROCESS.RequestAddDoc) {
  //   return <DepartmentRequestDocStep />;
  // }

  if (smartserviceId === 'WPM') {
    return <WorkPermisStep isRequestAddDoc={isRequestAddDoc} />
  }

  if (smartserviceId === 'DWPA' || smartserviceId === 'DWPR' || smartserviceId === 'DWPC') {
    return <WorkPermisEditorStep isRequestAddDoc={isRequestAddDoc} />
  }

  // DepartmentRequestDocStep
  switch (smartserviceName) {
    case "Smart T":
      return <SmartTStep isRequestAddDoc={isRequestAddDoc} />;

    case "Smart E":
      return <SmartEStep isRequestAddDoc={isRequestAddDoc} />;
    case "Smart I":
      return <SmartIStep isRequestAddDoc={isRequestAddDoc} />;
    case "Smart O":
      return <SmartOStep isRequestAddDoc={isRequestAddDoc} />;
    case "Smart S":
      return <SmartSStep isRequestAddDoc={isRequestAddDoc} />;

    default: {
      if (smartserviceNameLTR == "WGC") {
        return <LTR_GlobalCitizen isRequestAddDoc={isRequestAddDoc} />;
      }
      if (smartserviceNameLTR == "WFTP") {
        return <LTR_WFT isRequestAddDoc={isRequestAddDoc} />;
      }
      if (smartserviceNameLTR == "WP") {
        return <LTR_Pensioner isRequestAddDoc={isRequestAddDoc} />;
      }
      if (smartserviceNameLTR == "AFQEFD") {
        return <LTR_Dependent isRequestAddDoc={isRequestAddDoc} />;
      }
      if (smartserviceNameLTR == "HSG") {
        return <LTR_Goverment isRequestAddDoc={isRequestAddDoc} />;
      }
      if (smartserviceNameLTR == "HSPC") {
        return <LTR_Private isRequestAddDoc={isRequestAddDoc} />;
      }

      return <SmartTStep isRequestAddDoc={isRequestAddDoc} />;
    }
  }
}
